type SquadRequest = {
  /** Whether the league's rows carry their squads. */
  hasSquads: boolean;
  /** Whether a row has been opened. */
  isEntrySelected: boolean;
  /** Whether the separately read squad has arrived. */
  hasData: boolean;
  /** Whether a read is in flight, including a retry after an error. */
  isFetching: boolean;
  /** Whether the last read failed. */
  isError: boolean;
};

/**
 * Whether the team modal shows its squad as loading or failed, for a league
 * whose rows carry no squads so the opened row's squad is read on its own.
 *
 * Driven by `isFetching` rather than the query's first-load flag: a retry
 * after an error is still in the error state while it runs, and should read
 * as loading, not as a failure with its retry button still live. Once a squad
 * has arrived it stays on screen through later refetches, failed or not.
 */
export const resolveSquadRequestState = ({
  hasSquads,
  isEntrySelected,
  hasData,
  isFetching,
  isError
}: SquadRequest): { isSquadLoading: boolean; isSquadError: boolean } => {
  if (hasSquads || !isEntrySelected || hasData) {
    return { isSquadLoading: false, isSquadError: false };
  }

  if (isFetching) return { isSquadLoading: true, isSquadError: false };

  return { isSquadLoading: !isError, isSquadError: isError };
};
